<template>
    <!-- <div> -->
        <!-- Navbar -->
        <nav class="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme">
            <div class="container-xxl">

                <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
                    <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)" @click="visibleLeft = true">
                        <i class="mdi mdi-menu mdi-24px"></i>
                    </a>
                </div>

                <Sidebar v-model:visible="visibleLeft">
                    <aside id="layout-menu" class="layout-menu menu menu-vertical">
                        <div class="container-xxl d-flex h-100 flex-column p-0">
                            
                            <!-- <a href="#" class="menu-horizontal-prev d-none"></a> -->

                            <div class="navbar-brand app-brand demo d-xl-flex py-0 me-4">
                                <router-link to="/dashboard" class="app-brand-link gap-2">
                                    <span class="app-brand-logo demo"><img src="@/assets/logonsia.png" style="width:150px"/></span>
                                    <!-- <span class="app-brand-text demo menu-text fw-bold">NSIA ASSURANCE</span> -->
                                </router-link>
                            </div>
                <ul class="menu-inner overflow-auto">
                    <!-- Dashboards -->
                    <li  :class="this.$route.name == 'dashboard' ? 'menu-item active' : 'menu-item' ">
                        <router-link to="/dashboard" class="menu-link">
                            <i class="menu-icon tf-icons mdi mdi-home"></i>
                            <div data-i18n="Dashboards">Tableau de bord</div>
                        </router-link>
                    </li>

                    <!-- Bandes -->
                    <li v-if="false" :class=" {'active': this.$route.name === 'prospects', 'menu-item' : true, }">
                        <router-link to="/prospects" class="menu-link">
                            <span class="menu-icon mdi mdi-file"></span>
                            <div data-i18n="Dashboards">Prospects</div>
                        </router-link>
                    </li>
                        <li :class="{'active': this.$route.name === 'propectss', 'menu-item' : true, 'open' : open_aliment}" @mouseover="open_aliment=true" @click="open_aliment=true" @mouseleave="open_aliment=false">
                                    <a href="javascript:void(0)" class="menu-link menu-toggle">
                                        <span class="menu-icon mdi mdi-file"></span>
                                        <div data-i18n="Dashboards">Prospects</div>
                                    </a>
                                    <ul class="menu-sub">
                                        <li  :class=" {'active': this.$route.name === 'prospects', 'menu-item' : true, }">
                                            <router-link to="/prospects" class="menu-link">
                                                <span class="menu-icon mdi mdi-file"></span>
                                                <div data-i18n="Dashboards">Fiche Prospects</div>
                                            </router-link>
                                        </li>
                                        <li class="menu-item">
                                            <a href="javascript:void(0)"  class="menu-link">
                                                <span class="menu-icon mdi mdi-calendar-range"></span>
                                            <div data-i18n="Without menu">Programme d'activité</div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li  class="menu-item">
                                    <router-link to="/dashboard" class="menu-link">
                                        <span class="menu-icon mdi mdi-file"></span>
                                        <div data-i18n="Dashboards">Appel d'offre</div>
                                    </router-link>
                                </li>

                                <!-- Pondeuses -->
                                <li v-if="user.profil=='administrateur'" @mouseover="open_pondeuse=true" @click="open_pondeuse=true" @mouseleave="open_pondeuse=false" :class="{'active': this.$route.name === 'utilisateurs' || this.$route.name === 'secteurs' || this.$route.name === 'garanties' || this.$route.name === 'prospections', 'menu-item' : true, 'open' : open_pondeuse}">
                                    <a href="javascript:void(0)" class="menu-link menu-toggle">
                                        <span class="menu-icon mdi mdi-cog"></span>
                                        <div data-i18n="Dashboards">Paramètres</div>
                                    </a>
                                    <ul class="menu-sub">
                                        <li :class="this.$route.name == 'utilisateurs' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/utilisateurs" class="menu-link">
                                                <span class="menu-icon mdi mdi-account"></span>
                                                <div data-i18n="Without menu">Utilisateurs</div>
                                            </router-link>
                                        </li>
                                        
                                        <li :class="this.$route.name == 'garanties' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/garanties" class="menu-link">
                                                <span class="mdi mdi-format-list-bulleted menu-icon"></span>
                                                <div data-i18n="Without menu">Garanties</div>
                                            </router-link>
                                        </li>
                                        <li :class="this.$route.name == 'secteurs' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/secteurs" class="menu-link">
                                                <span class="mdi mdi-format-list-bulleted menu-icon"></span>
                                                <div data-i18n="Without menu">Secteurs</div>
                                            </router-link>
                                        </li>
                                        <li :class="this.$route.name == 'prospections' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/prospections" class="menu-link">
                                                <span class="mdi mdi-format-list-bulleted menu-icon"></span>
                                                <div data-i18n="Without menu">Natures prospections</div>
                                            </router-link>
                                        </li>
                                        
                                    </ul>
                                </li>

                    
                    
                    
            
                    
                </ul>
                            
                            <div class="menu-horizontal-wrapper"></div>
                            <!-- <a href="#" class="menu-horizontal-prev d-none"></a> -->

                        </div>
                    </aside>
                </Sidebar>

                

                <div class="navbar-brand app-brand demo d-xl-flex py-0 me-4">

                    <!-- <a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto d-xl-none">
                        <i class="mdi mdi-close align-middle"></i>
                    </a> -->
                            <router-link to="/dashboard" class="app-brand-link gap-2">
                                    <span class="app-brand-logo"><img src="@/assets/logonsia.png" style="width:150px"/></span>
                                    
                            </router-link>
                </div>

                <div class="navbar-nav-right d-flex align-items-center">

                    <ul class="navbar-nav flex-row align-items-center ms-auto">    
                        <!-- User -->
                        <li class="nav-item navbar-dropdown dropdown-user dropdown">
                            <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                                <div class="avatar avatar-online">
                                    <img src="@/assets/img/avatars/1.png" alt class="w-px-40 h-auto rounded-circle" />
                                </div>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li>
                                    <a class="dropdown-item" href="javascript:void(0);">
                                        <div class="d-flex">
                                            <div class="flex-shrink-0 me-3">
                                                <div class="avatar avatar-online">
                                                    <img src="@/assets/img/avatars/1.png" class="w-px-40 h-auto rounded-circle" />
                                                </div>
                                            </div>
                                            <div class="flex-grow-1">
                                                <span class="fw-semibold d-block">
                                                    {{ user.nom }} {{ user.prenoms }}
                                                </span>
                                                <small class="text-muted">
                                                   {{ user.profil }}
                                                </small>
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <div class="dropdown-divider"></div>
                                </li>

                                <li>
                                    <a class="dropdown-item" @click="deconnexion"
                                        href="javascript:void(0);">
                                        <i class="mdi mdi-logout me-2"></i>
                                        <span class="align-middle">Déconnexion</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <!--/ User -->
                    </ul>
                </div>

            </div>
        </nav>
        <!-- / Navbar -->
    <!-- </div> -->
</template>
  
<script>

    import { mapGetters } from "vuex";
    import menu from "@/functions/menu.js";
    export default {
        name: 'NavBar',
        props: {
            msg: String
        },
        data(){
            return { visibleLeft: false,
                user : {},
                open_bande : false,
                open_pondeuse : false,
                open_aliment : false,
                open_medicament : false,
        }
        },
        mounted(){
            menu()
            this.user = {...this.$store.state.user}
            
        },
        computed: 
        {
            ...mapGetters(['administrateur'])
        },
        methods:
        {
            async deconnexion()
            {
                await this.$store.commit('LogOut');
                window.location.reload()
            }
        }
    }
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>
  